<template>
    <div>
        <div class="header-mobile" v-if="isSizeMd" v-scroll="handleScroll" ref="headerMobile">
            <transition name="fade">
                <div class="header-mobile-header" v-if="showMobileHeaderMenu">
                    <div class="location">
                        <ButtonLocation :isSizeMd="true"></ButtonLocation>
                    </div>
                    <Logo></Logo>
                    <div class="personal">
                        <ButtonPersonal></ButtonPersonal>
                    </div>
                </div>
            </transition>
            <div class="header-mobile-body" :class="{'fixed': fixedMobileBody}">
                <div class="button-menu" @click="openMobileMenu">
                    <span class="pp-icon pp-icon-menu"></span>
                </div>
                <div class="header-mobile-phone">
                    <a :href="'tel:' + pizzeriaInfo.phone_full" class="phone">
                        {{pizzeriaInfo.phone_short}}
                    </a>
                </div>
                <ButtonBasket></ButtonBasket>
            </div>
            <div class="header-mobile-footer">
                <CategoryMenu></CategoryMenu>
            </div>
        </div>

        <MobileMenu v-if="isOpenMobileMenu"></MobileMenu>

        <div id="header" class="header" :style="{paddingTop: paddingTop + 'px'}" ref="header">
            <div class="header-header" v-if="!isSizeMd" >
                <div @click="openModalFreeDeliveryShareCondition" class="pizzeria-work-time"
                     v-html=" phrases.TEXT_60MIN_OR_FREE_PIZZA + ' ' + pizzeriaInfo.phone_short + ' • ' + schedule()">
                </div>
                <div class="pizzeria-delivery-area">
                    <div v-scroll-to="'#footer-map'" class="button-delivery-area">{{phrases.TEXT_ADDRESS_DELIVERY_ZONE}}</div>
                </div>
                <div class="pizzeria-socs">
                    <a :href="pizzeriaInfo.socs?.vk_link"  v-if="pizzeriaInfo.socs?.vk_link !== null" target="_blank" class="pp-icon pp-icon-vk"></a>
                    <a :href="pizzeriaInfo.socs?.telegram_link" v-if="pizzeriaInfo.socs?.telegram_link !== null" target="_blank" class="pp-icon pp-icon-telegram"></a>
                    <a :href="pizzeriaInfo.socs?.max_link" v-if="pizzeriaInfo.socs?.max_link !== null" target="_blank" class="pp-icon pp-icon-max"></a>
                </div>
                <ButtonLang></ButtonLang>
            </div>
            <div class="header-body" v-if="banners.length" >
                <HeaderSlider :sliders="banners"></HeaderSlider>
            </div>
            <div class="header-footer" v-if="!isSizeMd" >
                <div class="header-footer-header">
                    <Logo></Logo>
                    <ButtonLocation></ButtonLocation>
                    <div class="header-menu">
                        <div class="menu-item" v-for="(menuItem, index) in headerMenu" :key="index">
                            <a class="menu-item-link" :href="menuItem.link">{{menuItem.title}}</a>
                        </div>
                    </div>
                    <div class="header-buttons">
                        <ButtonPersonal></ButtonPersonal>
                        <ButtonBasket></ButtonBasket>
                    </div>
                </div>
                <div class="header-footer-body"></div>
            </div>
        </div>

        <CategoryMenu v-if="!isSizeMd"></CategoryMenu>

        <FilterMenu v-if="isOpenFilter"></FilterMenu>

        <div v-scroll="handleScroll">
            <CategoryMenu v-if="!isSizeMd && fixedDescTopMenu" v-bind:isFixed="true">
                <template v-slot:left_side>
                    <div class="button-scroll-top" v-scroll-to="'#header'">
                        <span class="pp-icon pp-icon-arrow-up-circle"></span>
                    </div>
                </template>
                <template v-slot:right_side>
                    <div class="header-buttons">
                        <ButtonPersonal></ButtonPersonal>
                        <ButtonBasket></ButtonBasket>
                    </div>
                </template>
            </CategoryMenu>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Utils from "../Utils";
    import ButtonPersonal from "../buttons/ButtonPersonal";
    import ButtonBasket from "../buttons/ButtonBasket";
    import ButtonLocation from "../buttons/ButtonLocation";
    import ButtonLang from "../buttons/ButtonLang";
    import MobileMenu from "../MobileMenu";
    import FilterMenu from "../FilterMenu";
    import CategoryMenu from "../CategoryMenu";
    import Logo from "./logo";
    import HeaderSlider from "./header/HeaderSlider";

    export default {
        name: "Header",
        data: function(){
            return {
                showMobileHeaderMenu: true,
                fixedMobileBody: false,
                paddingTop: false,
                fixedDescTopMenu: false
            };
        },
        methods:{
            schedule: function () {
                if(this.pizzeriaInfo.schedule !== undefined) {
                    const start = ("0" + this.pizzeriaInfo.schedule.start + ":00").substr(-5);
                    const finish = ("0" + this.pizzeriaInfo.schedule.finish + ":00").substr(-5);
                    return [this.phrases.TEXT_FROM, start, this.phrases.TEXT_TO, finish].join(" ");
                }else {
                    return null;
                }
            },
            handleScroll: function () {
                if(this.isSizeMd) {
                    if(this.$refs.headerMobile !== undefined && this.$refs.headerMobile.clientHeight !== undefined){
                        this.paddingTop = this.$refs.headerMobile.clientHeight;
                        if (window.scrollY > 50) {
                            this.showMobileHeaderMenu = false;
                            this.fixedMobileBody = true;
                        } else {
                            this.showMobileHeaderMenu = true;
                            this.fixedMobileBody = false;
                        }
                    }
                }else {
                    if(this.$refs.header !== undefined) {
                        this.paddingTop = 0;
                        const headerHeight = this.$refs.header.clientHeight;
                        if (window.scrollY > headerHeight) {
                            this.fixedDescTopMenu = true;
                        } else {
                            this.fixedDescTopMenu = false;
                        }
                    }
                }
            },
            openModalFreeDeliveryShareCondition: function () {
              this.$store.commit('app/setShowModalFreeDeliveryShareCondition', true);
            }
        },
        computed: {
            ...mapGetters('order', {
                total: 'total',
            }),
            ...mapGetters('user', {
                isAuthorize: 'isAuthorize',
                bonuses: 'getBonuses',
            }),
            ...mapGetters('app', {
                phrases: 'getPhrases',
                headerMenu: 'getHeaderMenu',
                banners: 'getBanners',
                pizzeriaInfo: 'getPizzeriaInfo',
                pizzeriaCityCode: 'getCityCode',
                isSizeMd: 'getIsSizeMd',
                isOpenMobileMenu: 'isOpenMobileMenu',
                isOpenFilter: 'isOpenFilter',
            }),
            ...mapGetters('catalog', {
                groups: 'getGroups',
            }),
        },
        components: {
          HeaderSlider,
          Logo,
          ButtonLocation,
          ButtonPersonal,
          ButtonBasket,
          ButtonLang,
          MobileMenu,
          FilterMenu,
          CategoryMenu
        },
        updated() {
            this.handleScroll();
        },
        mixins: [Utils]
    }
</script>

<style scoped lang="scss">
    .fade-enter-active {
        transition: all .3s ease;
    }
</style>
